import React, { useEffect, useState } from 'react'
import QRCode from 'qrcode'

interface Props {
  title: string
  subtitle?: string
  url: string
  shareText: string
  onClose: () => void
}

export default function ShareModal({ title, subtitle, url, shareText, onClose }: Props) {
  const [qr, setQr] = useState('')
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    QRCode.toDataURL(url, {
      width: 260, margin: 1,
      color: { dark: '#00FFD1', light: '#00000000' },
    }).then(setQr).catch(() => {})
  }, [url])

  const doShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: 'tingl', text: shareText, url }) } catch {}
    } else {
      copy()
    }
  }

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 1800)
    } catch {}
  }

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
      style={{
        position: 'fixed', inset: 0, zIndex: 700,
        background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(10px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
    >
      <div className="fade-in" style={{
        width: '100%', maxWidth: 360, background: '#101010',
        border: '1px solid rgba(0,255,209,0.25)', borderRadius: 28,
        padding: '28px 22px', textAlign: 'center',
      }}>
        <div className="eyebrow" style={{ marginBottom: 4 }}>{subtitle || 'share'}</div>
        <div className="syne" style={{ fontWeight: 800, fontSize: 20, letterSpacing: '-0.03em', marginBottom: 18 }}>
          {title}
        </div>

        {qr && (
          <div style={{
            display: 'inline-block', padding: 14, borderRadius: 20,
            background: 'rgba(0,255,209,0.05)', border: '1px solid rgba(0,255,209,0.15)',
            marginBottom: 16,
          }}>
            <img src={qr} alt="QR code" style={{ display: 'block', width: 200, height: 200 }} />
          </div>
        )}

        <div style={{
          fontSize: 13, color: 'var(--mint)', fontFamily: 'Space Grotesk',
          fontWeight: 600, marginBottom: 18, wordBreak: 'break-all',
        }}>
          {url.replace('https://', '')}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
          <button className="pill grad" style={{ padding: '13px' }} onClick={doShare}>
            Share ⇗
          </button>
          <button className="pill ghost" style={{ padding: '13px' }} onClick={copy}>
            {copied ? 'copied ✓' : 'Copy link'}
          </button>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: 'var(--text-faint)',
            fontFamily: 'Space Grotesk', fontSize: 13, cursor: 'pointer', marginTop: 4,
          }}>close</button>
        </div>
      </div>
    </div>
  )
}
